/** Textos sobre uso no celular / PWA na landing pública (hero + rodapé). */

export const LANDING_HERO_TRUST_PWA_LABEL = 'App no seu celular';

export const LANDING_FOOTER_PWA_LINE =
  'No celular: adicione o RetornaAr à tela inicial pelo navegador — ícone próprio e abre em tela cheia.';

export const LANDING_FOOTER_PWA_FAQ_LINK_LABEL = 'Passo a passo no FAQ';
